import React, { useMemo, useEffect, useState } from 'react';

export const funTradingFacts = [
    "Did you know? The first stock ever traded was the Dutch East India Company in 1602.",
    "Fun fact: The NYSE started under a buttonwood tree in 1792!",
    "Did you know? Warren Buffett bought his first stock at age 11.",
    "Fun fact: The term 'blue chip' comes from poker.",
    "Did you know? The 'January Effect' suggests stocks often rise in January.",
    "Fun fact: The most expensive stock is Berkshire Hathaway at over $500,000 per share.",
    "Did you know? There are over 60 major stock exchanges worldwide.",
    "Fun fact: The average day trader loses money—discipline is key!",
    "Did you know? Stock market trading floors now mostly run on algorithms.",
    "Fun fact: The VIX index is nicknamed the 'fear index'.",
    "Did you know? The term 'bull market' comes from how bulls attack—upward!",
    "Fun fact: The 'bear market' name comes from bears swiping down.",
    "Did you know? You can trade stocks while sipping coffee in your pajamas.",
    "Fun fact: Japan's stock market is one of the largest after the US and China.",
    "Did you know? The Nasdaq is heavily tech-focused.",
    "Fun fact: Trading halts happen when prices move too fast.",
    "Did you know? Some traders use astrology—called financial astrology!",
    "Fun fact: Tesla once traded more than the entire S&P 500 combined—in volume.",
    "Did you know? The stock ticker was invented in 1867.",
    "Fun fact: A company going public is called an IPO—Initial Public Offering.",
    "Did you know? The London Stock Exchange was founded in a coffee house.",
    "Fun fact: Forex trading is open 24 hours a day during the week.",
    "Did you know? Cryptocurrency markets never close—not even on holidays.",
    "Fun fact: The smallest unit of a stock price is called a tick.",
    "Did you know? ‘Paper trading’ means practicing without risking real money.",
    "Fun fact: Insider trading is illegal—unless it's public knowledge.",
    "Did you know? Stock splits make shares cheaper without changing value.",
    "Fun fact: The Dow Jones Index began with just 12 companies.",
    "Did you know? Some traders make decisions in milliseconds with HFTs.",
    "Fun fact: Investing legend Peter Lynch said 'Invest in what you know.'",
    "Did you know? Diversification is like not putting all your eggs in one basket.",
    "Fun fact: Inflation can eat into investment returns over time.",
    "Did you know? Some companies pay dividends—your reward for holding their stock.",
    "Fun fact: The Great Depression started with the 1929 stock market crash.",
    "Did you know? Bitcoin's first transaction bought two pizzas in 2010.",
    "Fun fact: ETFs let you invest in a bundle of assets at once.",
    "Did you know? Index funds aim to match—not beat—the market.",
    "Fun fact: You can buy fractional shares—own a slice of a stock.",
    "Did you know? Margin trading means borrowing money to trade.",
    "Fun fact: Short sellers profit when stocks fall—not rise.",
    "Did you know? A candlestick chart originated in Japan in the 1700s.",
    "Fun fact: Warren Buffett still lives in the same house he bought in 1958.",
    "Did you know? 'Stop-loss' orders can help protect your downside.",
    "Fun fact: Black Monday (1987) saw the Dow drop 22% in one day.",
    "Did you know? Stock prices move based on expectations—not just facts.",
    "Fun fact: Meme stocks like GameStop shocked Wall Street in 2021.",
    "Did you know? The Fear & Greed Index gauges market emotion.",
    "Fun fact: Options give you the right, but not obligation, to buy/sell.",
    "Did you know? Some stocks are called 'unicorns' before they IPO.",
    "Fun fact: Liquidity means how easily you can buy/sell something.",
    "Did you know? A ‘bagholder’ is someone stuck with a falling stock.",
    "Fun fact: A ‘dead cat bounce’ is a brief rally in a downtrend.",
    "Did you know? Market makers help ensure trading flows smoothly.",
    "Fun fact: 'Buy the rumor, sell the news' is a popular strategy.",
    "Did you know? SPACs are shell companies that merge with real businesses.",
    "Fun fact: Volatility isn't always bad—traders often love it!",
    "Did you know? The SEC (U.S.) and FCA (U.K.) regulate financial markets.",
    "Fun fact: Stock tickers like AAPL and TSLA are brand identities now.",
    "Did you know? The Russell 2000 tracks small-cap U.S. companies.",
    "Fun fact: Day trading requires high focus and caffeine (usually).",
    "Did you know? Swing traders hold positions for days or weeks.",
    "Fun fact: A ‘golden cross’ signals bullish momentum.",
    "Did you know? A ‘death cross’ may signal bearish trends.",
    "Fun fact: Fibonacci numbers are used in trading analysis.",
    "Did you know? The first ETF was launched in Canada in 1990.",
    "Fun fact: ‘Pump and dump’ scams are illegal and risky.",
    "Did you know? Some investors prefer ESG (Ethical/Social/Governance) stocks.",
    "Fun fact: Hedging is like buying insurance for your trades.",
    "Did you know? High-frequency traders use fiber-optic cables for speed.",
    "Fun fact: The crypto market cap once surpassed $3 trillion.",
    "Did you know? The S&P 500 represents about 80% of U.S. market value.",
    "Fun fact: Diversification doesn’t guarantee profits—but it helps reduce risk.",
    "Did you know? BlackRock manages over $10 trillion in assets.",
    "Fun fact: Leverage amplifies gains—and losses!",
    "Did you know? The dot-com bubble burst in 2000 wiped out trillions.",
    "Fun fact: Some traders use dual monitors—or five!",
    "Did you know? RSI and MACD are two popular technical indicators.",
    "Fun fact: The ‘Robinhood effect’ made trading cool again for Gen Z.",
    "Did you know? Gold is seen as a safe haven in market turmoil.",
    "Fun fact: Commodities like oil, corn, and soybeans are traded too.",
    "Did you know? Bonds pay interest and are seen as safer than stocks.",
    "Fun fact: Insider ownership often signals confidence in a company.",
    "Did you know? Market bubbles often form from investor over-optimism.",
    "Fun fact: Charts tell stories—if you know how to read them.",
    "Did you know? Liquidity dries up fast during panic sell-offs.",
    "Fun fact: Technical and fundamental analysis are often blended together.",
    "Did you know? The 'efficient market hypothesis' says prices reflect all info.",
    "Fun fact: In trading, your worst enemy is often yourself.",
    "Did you know? The S&P 500 hit record highs even during crises.",
    "Fun fact: Some traders meditate to manage emotions.",
    "Did you know? Compound interest is called the 8th wonder of the world.",
    "Fun fact: Rebalancing your portfolio keeps your risk in check.",
    "Did you know? Even billionaires lose money in the markets sometimes.",
    "Fun fact: The market has recovered from every crash—eventually.",
    "Did you know? Buying during a panic is often when fortunes are made.",
    "Fun fact: 'Time in the market' beats 'timing the market'.",
  ];
  
//   const AhaLoadingOverlay = ({ message = 'Transferring your Aha moment...' }) => {
//     const randomFact = useMemo(() => {
//       const index = Math.floor(Math.random() * funTradingFacts.length);
//       return funTradingFacts[index];
//     }, []);
  
//     return (
//       <div style={{
//         position: 'fixed',
//         top: 0,
//         left: 0,
//         height: '100vh',
//         width: '100vw',
//         backgroundColor: 'rgba(0, 0, 0, 0.95)',
//         zIndex: 9999,
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         color: '#FF7C24',
//         fontFamily: 'Nunito Sans, sans-serif',
//       }}>
//         {/* Spinner */}
//         <div style={{
//           width: '64px',
//           height: '64px',
//           border: '8px solid #f3f3f3',
//           borderTop: '8px solid #FF7C24',
//           borderRadius: '50%',
//           animation: 'spin 1s linear infinite',
//           marginBottom: '20px'
//         }} />
  
//         {/* Primary Message */}
//         <div style={{ fontSize: '22px', fontWeight: 'bold', marginBottom: '10px', textAlign: 'center' }}>
//           🚀 {message}
//         </div>
  
//         {/* Fun Fact */}
//         <div style={{
//           fontSize: '16px',
//           fontStyle: 'italic',
//           color: '#FFFFFF',
//           textAlign: 'center',
//           maxWidth: '80%',
//           lineHeight: '1.4',
//           marginBottom: '12px'
//         }}>
//           Fun fact: {randomFact}
//         </div>
  
//         {/* Support Line */}
//         <div style={{ fontSize: '13px', color: '#AAAAAA' }}>
//           Hang tight, your insight is being crafted!
//         </div>
  
//         {/* Spinner animation keyframes */}
//         <style>
//           {`
//             @keyframes spin {
//               0% { transform: rotate(0deg); }
//               100% { transform: rotate(360deg); }
//             }
//           `}
//         </style>
//       </div>
//     );
//   };
  
//   export default AhaLoadingOverlay;


const AhaLoadingOverlay = ({ message = 'Hang tight, your insight is being crafted...' }) => {
    const randomFact = useMemo(() => {
      const index = Math.floor(Math.random() * funTradingFacts.length);
      return funTradingFacts[index];
    }, []);
  
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100vh',
        width: '100vw',
        backgroundColor: 'rgba(0, 0, 0, 0.94)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'var(--font-primary)', // Nunito Sans from GlobalStyles
        padding: '1rem',
      }}>
        {/* Spinner */}
        <div style={{
          width: '64px',
          height: '64px',
          border: '6px solid rgba(255, 255, 255, 0.2)',
          borderTop: '6px solid var(--main-orange)',
          borderRadius: '50%',
          animation: 'spin 1.2s linear infinite',
          marginBottom: '1.5rem'
        }} />
  
        {/* Main Message */}
        <div style={{
          fontSize: 'var(--title1-size)',
          color: 'var(--main-orange)',
          fontWeight: '700',
          textAlign: 'center',
          marginBottom: '1rem',
          padding: '0 1rem'
        }}>
          🚀 {message}
        </div>
  
        {/* Fun Fact */}
        <div style={{
          fontSize: 'var(--callout-size)',
          color: 'var(--main-white)',
          fontStyle: 'italic',
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          padding: '12px 16px',
          borderRadius: '16px',
          maxWidth: '90%',
          textAlign: 'center',
          marginBottom: '1rem',
          lineHeight: '1.5'
        }}>
          {randomFact}
        </div>
  
        {/* Sub Message */}
        <div style={{
          fontSize: 'var(--footnote-size)',
          color: '#CCCCCC',
          textAlign: 'center',
          marginTop: '0.5rem'
        }}>
          
        </div>
  
        {/* Spinner Animation */}
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>
    );
  };
  
  export default AhaLoadingOverlay;